import React from 'react';
import { TextField } from '@mui/material';

const EmailInput = ({ item, index, signed = false, onChange }) => {
  const handleChange = (e) => {
    const value = e.target.value;
    if (onChange) {
      onChange(value);
    } else {
      item.answer = value;
    }
  };

  return (
    <div>
      <TextField
        size="small"
        type="email"
        variant="outlined"
        fullWidth
        placeholder="Enter your email..."
        disabled={signed}
        value={item.answer || ''}
        onChange={handleChange}
        style={{
          maxWidth: '300px',
          marginTop: '10px'
        }}
      />
    </div>
  );
};

export default EmailInput;
